import styled from "styled-components"

export const PagerWrapper = styled.div`
  .disabled {
    color: #979797;
    cursor: default;
    pointer-events: none;
  }
`
